import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import AADHeader from "./components/AADHeader.js";
import SiteAnomaliesPanel from "./components/anomaly/SiteAnomaliesPanel";
import { isElectricityMetric } from "./services/anomalyApi";

export default function SiteAnomaliesPage() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const slParam = urlSearchParams.get("sl") || "";
  const esg = urlSearchParams.get("esg") || "";
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth >= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderHeader = () => {
    const authType = localStorage.getItem("authType");
    if (authType === "AAD") return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />;
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />;
  };

  return (
    <div id="wrapper">
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div
        id="page-content-wrapper"
        className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}
      >
        <div className="formpd">
          <div className="flex mb-3">
            <div className="col-md-12">
              <div Class="steps__containt-hader">
                <h3 className="title">Anomalies</h3>
                <div role="presentation">
                  <Breadcrumbs
                    aria-label="breadcrumb"
                    separator={<NavigateNextIcon fontSize="small" />}
                  >
                    <Link to="/allconfiguration" className="breadcrumbs-font">
                      Configuration
                    </Link>
                    <Typography color="text.primary">Anomalies</Typography>
                  </Breadcrumbs>
                </div>
              </div>
            </div>
          </div>

          {!slParam ? (
            <p className="text-muted">
              No site selected. Open this page from <strong>Anomalies</strong> on All Configurations.
            </p>
          ) : !isElectricityMetric(esg) ? (
            <p className="text-muted">
              Anomaly detection is available for Purchase Electricity only (ESG: {esg || "—"}).
            </p>
          ) : (
            <SiteAnomaliesPanel siteLocationId={slParam} esgMetric={esg} />
          )}
        </div>
      </div>
    </div>
  );
}
